module.exports = __webpack_public_path__ + "img/collection_fruit.613b9ad5.png";